import { useEffect, useRef } from "react";

// type UseSafePollingOptions = {
// 	delay: number; // délai entre chaque tentative en ms
// 	timeoutThreshold?: number; // durée max autorisée pour un appel (par défaut égal à `delay`)
// 	enabled?: boolean; // permet d'activer/désactiver dynamiquement
// };

export const useSafePolling = (asyncCallback, { delay, timeoutThreshold, enabled = true }) => {
	const isMounted = useRef(true);
	const isRunning = useRef(false);
	const savedCallback = useRef(asyncCallback);
	const timeoutRef = useRef(null);

	// Mise à jour de la référence à la fonction si elle change
	useEffect(() => {
		savedCallback.current = asyncCallback;
	}, [asyncCallback]);

	useEffect(() => {
		isMounted.current = true;

		if (!enabled) return;

		const tick = async () => {
			if (!isMounted.current || isRunning.current) return;

			isRunning.current = true;
			const start = Date.now();

			try {
				await savedCallback.current();
			} catch (error) {
				if (error?.response?.status === 401) {
					console.warn("User not authenticated, stopping polling");
					isMounted.current = false; // ou appeler une fonction stopPolling()
				}
				console.error("Polling error:", error);
			} finally {
				isRunning.current = false;

				const duration = Date.now() - start;
				const maxDuration = timeoutThreshold ?? delay;

				if (!isMounted.current) return;

				if (duration < maxDuration) {
					timeoutRef.current = setTimeout(tick, delay - duration);
				} else {
					console.warn("Polling skipped: asyncCallback took too long");
					timeoutRef.current = setTimeout(tick, delay); // on re-poll après le délai complet
				}
			}
		};

		tick(); // appel initial

		return () => {
			isMounted.current = false;
			isRunning.current = false;
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, [delay, timeoutThreshold, enabled]);
};
